import React from 'react';
import PropTypes from 'prop-types';
import { Add as AddIcon } from '@mui/icons-material';

import { Box } from '@mui/material';
import { isEmpty } from 'lodash';
import { isMobile } from '../../../../../common/services/isMobile';
import { Toolbar } from '../../../../../common/components/Toolbar/Toolbar';
import Button from '../../../../../common/components/Button/Button';
import { PageLabel } from '../../../../../common/components/Toolbar/PageLabel';

export { pageLabelStyle } from '../../../../../common/components/Toolbar/PageLabel';

function DictionaryToolbar(props) {
  const { title, openCreateDialog, buttons, hidePageLabel, hideAddButton } = props;
  const showSeparator = (!hideAddButton && openCreateDialog) || !isEmpty(buttons);
  const pageLabel = (!isMobile || !hidePageLabel) && <PageLabel showSeparator={showSeparator}>{title}</PageLabel>;

  const creationButton = !hideAddButton && openCreateDialog && (
    <Button className="dictionary-toolbar-btn" onClick={openCreateDialog} variant="contained">
      <AddIcon /> Add
    </Button>
  );

  return (
    <Toolbar>
      {pageLabel}

      <Box className="actions">
        {creationButton}
        {buttons}
      </Box>
    </Toolbar>
  );
}

DictionaryToolbar.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  buttons: PropTypes.node,
  openCreateDialog: PropTypes.func,
};

export default DictionaryToolbar;
